<template>
	<page title="Bestillingsliste">
		<div class="order">
			<div class="main" v-if="!successMsg">
				<div class="sections">
					<vSection v-for="section in sections" :key="section.id" v-bind="section"/>
					<selector v-if="selector" @close="selector = false"/>
				</div>

				<a class="new" @click="addSection" :class="{disabled: !noErrors}">
					<div class="icon" v-html="require('@/assets/icons/plus-light.svg')"/>
					Nyt produkt
				</a>



				<div class="send" v-if="sections.length > 1">
					<btn @click="review = true">Gennemse bestilling</btn>
					<btn v-bind="{loading}" @click="send">Indsend</btn>
				</div>
			</div>

			<div class="msg" v-else v-text="successMsg"/>

			<review v-if="review" @close="review = false"/>
		</div>
	</page>
</template>

<script>
import {date} from "@/modules/utils";
import vSection from "./section/index.vue";
import selector from "./section/selector.vue";
import page from "@/components/order/page.vue";
import btn from "@/components/button.vue";
import review from "./review.vue";

export default {
	components: {vSection, selector, page, btn, review},
	data() {
		return {
			loading: false,
			selector: false,
			successMsg: false,
			review: false
		}
	},
	computed: {
		user: (t) => t.$store.getters["user/data"],
		data: (t) => t.$store.getters["order/data"],
		reseller: (t) => t.$store.getters["user/reseller"],
		sections: (t) => t.$store.getters["order/sections"],
		noErrors: (t) => t.$store.getters["order/noErrors"]
	},
	methods: {
		initData() {
			const d = date(new Date() / 1000);

			this.$store.commit("order/sectionData", {
				id: "basic",
				data: {
					"Erhvervsordre": false,
					"Mærkning": "...",
					"Solgt af": this.user.name,
					"Dato": `${d.day}.${d.month}.${d.year}`,
					"Forhandler": this.reseller ? `${this.reseller.name} (${this.reseller.account_number})` : ""
				}
			});
		},

		addSection() {
			this.$store.commit("order/sectionsActive", {active: false});
			this.selector = true;
		},

		async send() {
			const el = document.querySelector("*[data-error=true]");
			if (this.loading) return;

			if (this.noErrors) {
				this.loading = true;
				const {message} = await this.$store.dispatch("order/send");
				this.successMsg = message;
				this.loading = false;
			} else {
				el.scrollIntoView();
				window.scrollBy(0, -300);
			}
		}
	},
	created() {
		this.initData();
	}
};
</script>

<style lang="scss" scoped>
.order {
	.main {
		.new {
			user-select: none;
			height: 70px;
			background-color: #E2E2E2;
			border: 1px solid #979797;

			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: 700;


			&.disabled {
				opacity: 0.2;
				pointer-events: none;
			}

			.icon {
				margin-right: 1em;

				/deep/ svg {
					$s: 15px;
					width: $s;
					height: $s;
				}
			}
		}

		.send {
			user-select: none;
			display: flex;
			justify-content: flex-end;
			margin-top: 28px;

			@include res(mobile) {
				flex-direction: column;
			}

			.button {
				text-transform: uppercase;
				background-color: #22313A;
				color: $white1;
				height: 40px;
				padding: 0 25px;
				font-weight: 300;
				display: flex;
				align-items: center;

				@include res(mobile){
					width: 100%;
				}

				&:first-child {
					margin: 0 10px 0 0;

					@include res(mobile) {
						margin: 0 0 10px 0;
					}
				}

				&:last-child {
					background-color: #466DA6;
				}
			}
		}
	}

	.msg {
		color: $green1;
		font-size: 18px;
	}
}
</style>
